import React from 'react'

import Layout from '../components/layout'
import LogAiPage from '../components/log-ai/LogAiPage'
import { LOG_AI_PT } from '../constants/logAiContent'

const LogAiPt = () => (
  <Layout
    lang="pt"
    title={LOG_AI_PT.seo.title}
    meta={{ description: LOG_AI_PT.seo.description }}
    rootProps={{ className: 'page log-ai' }}
  >
    <LogAiPage lang="pt" />
  </Layout>
)

export default LogAiPt
